// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__p7a6G","list":"PatternAutocomplete_list__3QtI8"};